import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { POLICY_LAST_UPDATED } from "./businessInfo";

/** Shared chrome + typography for every legal/policy page. */
export default function LegalLayout({
  title,
  intro,
  children,
  showUpdated = true,
}: {
  title: string;
  intro?: ReactNode;
  children: ReactNode;
  showUpdated?: boolean;
}) {
  return (
    <main className="theme-mkt bg-background-50 min-h-screen">
      <Navbar />
      <section className="pt-28 md:pt-36 pb-20 md:pb-28">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <Link to="/" className="text-xs font-medium text-primary-600 hover:text-primary-700">
            ← Back to home
          </Link>
          <h1 className="mt-4 text-3xl md:text-4xl font-heading font-bold text-foreground-900">
            {title}
          </h1>
          {showUpdated && (
            <p className="mt-2 text-xs text-foreground-400">Last updated: {POLICY_LAST_UPDATED}</p>
          )}
          {intro && <div className="mt-6 text-sm text-foreground-600 leading-relaxed">{intro}</div>}
          <div className="legal-prose mt-8 space-y-6 text-sm text-foreground-700 leading-relaxed">
            {children}
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}

/** A titled section block used inside the policy pages. */
export function Section({ heading, children }: { heading: string; children: ReactNode }) {
  return (
    <section>
      <h2 className="text-lg font-semibold text-foreground-900 mb-2">{heading}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
